export default __webpack_public_path__ + "static/media/banner.98b66880.jpg";